export default {
  'BANNERS' (state) {
    return state.banners
  }
}
